import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReceiptReducer } from '../reducers';

export const selectReceiptFeature = createFeatureSelector<ReceiptReducer.ReceiptState>(ReceiptReducer.featureName);

export const selectReceipt = createSelector(selectReceiptFeature, (state: ReceiptReducer.ReceiptState) => state.item);
